import { useEffect, useRef } from 'react';

// `useEffect` fires the first time a component renders, even though the dependencies haven't strictly "changed" - they
// have just gone from being undefined to being defined. This hook prevents that initial firing, so that the action
// is only called when the dependencies actually change - i.e. whenever they update after they've been initialised.
export const useOnChange = (action: () => void, dependencies: Array<unknown>) => {
  const hasFiredInitialTrigger = useRef(false);

  useEffect(() => {
    if (hasFiredInitialTrigger.current) {
      action();
    } else {
      hasFiredInitialTrigger.current = true;
    }
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps
};
